import { Observable } from 'rxjs/Rx'
import { combineEpics } from 'redux-observable'
import { post } from 'store/services/heartbeat'
import * as authenticationDuck from 'store/ducks/authentication'

// Actions

export const HEARTBEAT_REQUEST = 'heartbeat/_REQUEST'
export const HEARTBEAT_SUCCESS = 'heartbeat/_SUCCESS'
export const HEARTBEAT_FAILURE = 'heartbeat/_FAILURE'

export const heartbeatRequest = (payload) => ({
  type: HEARTBEAT_REQUEST,
})

export const heartbeatSuccess = (payload) => ({
  type: HEARTBEAT_SUCCESS,
})

export const heartbeatFailure = (payload) => ({
  type: HEARTBEAT_FAILURE,
})

// Epics
export const epic = combineEpics(postHeartbeatEpic)

export function postHeartbeatEpic(action$) {
  return action$.ofType(HEARTBEAT_REQUEST).mergeMap((action) =>
    Observable.ajax(post())
      .map((res) => heartbeatSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(heartbeatFailure(errors))
        } catch (e) {
          return Observable.of(heartbeatFailure())
        }
      }),
  )
}
